export default "__VITE_ASSET__BtpMrwfi__"